import { useFormContext, useWatch } from "react-hook-form";
import classNames from "classnames";
import ErrorMessage from "../ErrorMessage";
import styles from "./index.module.scss";
import Checkbox from "../Checkbox";

type PropsType = {
  section?: string;
  name: string;
  option1: {
    label: string;
    value: string;
  };
  option2?: {
    label: string;
    value: string;
  };
  label: string;
  disabled?: boolean;
  requiredText?: string;
  readOnly?: boolean;
};

const RadioDevice = ({
  section,
  name,
  requiredText,
  option1,
  option2,
  label,
  disabled,
  readOnly,
}: PropsType) => {
  const {
    formState: { errors },
  } = useFormContext();
  const nameDotFormat = (() => {
    if (section) {
      return `${section}.${name}`;
    }
    return `${name}`;
  })();
  const error =
    section && errors[section] ? errors[section][name] : errors[name];

  const selectedValue = useWatch({ name: nameDotFormat });
  return (
    <div
      className={classNames(styles.gridDevices, {
        [styles.gridDevicesOne]: !option2,
      })}
    >
      <div>
        {label && (
          <span className={styles.labelText}>
            {label}
            <span>
              {error && requiredText && (
                <ErrorMessage className={styles.errorHorizontal} field={name}>
                  {error.message}
                </ErrorMessage>
              )}
            </span>
          </span>
        )}
      </div>

      <fieldset
        className={classNames(styles.radioGroupFieldset, styles.horizontal)}
      >
        <>
          <Checkbox
            name={nameDotFormat}
            value={option1.value}
            label={option1.label}
            disabled={disabled || (readOnly && option1.value !== selectedValue)}
            requiredText={requiredText}
            readOnly={readOnly}
            className={styles.option1}
          />

          {option2 && (
            <Checkbox
              name={nameDotFormat}
              value={option2.value}
              label={option2.label}
              disabled={
                disabled || (readOnly && option2.value !== selectedValue)
              }
              requiredText={requiredText}
              readOnly={readOnly}
              className={styles.option2}
            />
          )}
        </>
      </fieldset>
      <div className={styles.line} />
    </div>
  );
};

export default RadioDevice;
